export * from './map';
export * from './map.interface';
export * from './map.service';
export * from './map-factory.service'



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/shared/index.ts